import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Seo } from "@/components/Seo";
import { posts } from "@/content/blog";
import { company } from "@/content/site";

export default function Blog() {
  return (
    <>
      <Seo title={`Blog | ${company.name}`} description="News and insights on tanker freight and trucking." />
      <section className="bg-brand-50">
        <div className="container py-16">
          <h1 className="text-3xl font-bold md:text-4xl">Blog</h1>
          <p className="mt-3 text-brand-700">News and insights on tanker freight and trucking.</p>
        </div>
      </section>

      <section className="container py-16">
        <div className="grid gap-6 md:grid-cols-2">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group min-w-0">
              <Card className="h-full overflow-hidden transition-shadow hover:shadow-md">
                {p.cover && (
                  <div className="aspect-[16/10] overflow-hidden bg-brand-900">
                    <img
                      src={p.cover}
                      alt=""
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                )}
                <CardContent className="pt-6">
                  <p className="text-xs text-brand-400">
                    {new Date(p.date).toLocaleDateString(undefined, {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                  <h2 className="mt-1 break-words text-lg font-semibold">{p.title}</h2>
                  <p className="mt-2 break-words text-sm text-brand-600">{p.excerpt}</p>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
